import { render, staticRenderFns } from "./PreviewMedia.vue?vue&type=template&id=fb8d18ce&scoped=true"
import script from "./PreviewMedia.vue?vue&type=script&lang=ts"
export * from "./PreviewMedia.vue?vue&type=script&lang=ts"
import style0 from "./PreviewMedia.vue?vue&type=style&index=0&id=fb8d18ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8d18ce",
  null
  
)

export default component.exports